export default "__VITE_ASSET__Dc2Y26k8__"